setTimeout(() => {
    let quickAddDrawer = document.querySelector('#js-cart-drawer')
    console.log('sa', quickAddDrawer)
    if (quickAddDrawer) {
        let observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(m) {
               console.log('test')
            });
        });
        observer.observe(quickAddDrawer, {
            childList: true
        });
    }
}, 2500);